import { Card, CardContent, Typography, Box, Divider } from '@mui/material'
import { useTranslator } from '@/hooks'
import { useState } from 'react'

export const FinancialSummaryPastDetail = ({ data }: { data: any }) => {
  const { __, __n } = useTranslator()
  const [showMore, setShowMore] = useState(false)

  const summaryItems = [
    {
      label: 'Total Transaction Fees',
      value: data?.service_fee?.service_fee,
      icon: 'tabler-wallet'
    },
    {
      label: 'Voucher',
      value: data?.voucher?.voucher,
      icon: 'tabler-receipt-tax'
    },
    {
      label: 'Employee Fee',
      value: data?.employee_fee?.employee_fee,
      icon: 'tabler-file-dollar'
    },
    {
      label: 'Disbursement Rate',
      value: data?.different?.total_actual_salary_reconcile
        ? Number(
            (
              (Number(data.different.total_ewa_disbursement) / Number(data.different.total_actual_salary_reconcile)) *
              100
            ).toFixed(2)
          )
        : 0,
      icon: 'tabler-scale',
      isNegative: true
    },
    {
      label: 'Cumulative Current Debt',
      value: data?.cumulative_current_debt?.cumulative_current_debt,
      icon: 'tabler-presentation-analytics'
    },
    {
      label: 'Total EWA Disbursement',
      value: data?.total_ewa_disbursement?.total_ewa_disbursement,
      icon: 'tabler-checkup-list'
    }
  ]

  const servicesDetailItems = [
    { label: 'Collected', value: data?.service_fee?.collected },
    { label: 'Debt', value: data?.service_fee?.debt }
  ]

  const totalEwaDisbursementItems = [
    { label: 'Collected', value: data?.total_ewa_disbursement?.collected },
    { label: 'Debt', value: data?.total_ewa_disbursement?.debt }
  ]

  const employeeFeeItems = [{ label: 'Collected', value: data?.employee_fee?.employee_fee_collected }]

  const voucherDetailItems = [
    { label: 'Collected', value: data?.voucher?.collected },
    { label: 'Debt', value: data?.voucher?.debt }
  ]

  const differentDetailItems = [
    { label: 'Total EWA disbursement', value: data?.different?.total_ewa_disbursement },
    { label: 'Total cummulative eligible amount', value: data?.different?.total_actual_salary_reconcile },
    { label: 'Pay Different', value: data?.different?.cus_pay_diff }
  ]

  const debtDetailItems = [
    {
      label: data?.cumulative_current_debt?.dept_month_current?.month,
      value: data?.cumulative_current_debt?.dept_month_current?.debt
    },
    {
      label: data?.cumulative_current_debt?.dept_month_current_month_1?.month,
      value: data?.cumulative_current_debt?.dept_month_current_month_1?.debt
    },
    {
      label: data?.cumulative_current_debt?.dept_month_current_month_2?.month,
      value: data?.cumulative_current_debt?.dept_month_current_month_2?.debt
    }
  ]

  const renderSummaryItem = (item: any, index: number) => (
    <div key={index} className='flex-1'>
      <div className='flex items-center gap-4 mb-3'>
        <Box className='flex items-center justify-between w-full gap-2'>
          <div className='flex flex-col'>
            <Typography
              className={`text-[24px] font-medium leading-[38px] ${
                item.isNegative
                  ? (Number(data?.different?.total_actual_salary_reconcile) || 0) >=
                    (Number(data?.different?.total_ewa_disbursement) || 0)
                    ? 'text-green-500'
                    : 'text-red-500'
                  : ''
              }`}
            >
              {item.isNegative ? `${item.value}%` : __n(item.value, 'đ')}
            </Typography>
            <Typography className='text-[15px] font-normal leading-[22px]'>{__(item.label)}</Typography>
          </div>
          <div className='flex items-center p-2 rounded-[6px] bg-gray-100'>
            <i className={`${item.icon}`} />
          </div>
        </Box>
      </div>

      {showMore && (
        <div className='space-y-1'>
          {index === 0 &&
            servicesDetailItems.map((detailItem, detailIndex) => (
              <div key={detailIndex}>
                <div className='flex flex-row gap-4 items-center py-1'>
                  <div className='flex flex-row items-center gap-2'>
                    <Typography className='text-[15px] font-normal leading-[22px]'>{__(detailItem.label)}</Typography>
                  </div>
                  <div className='flex items-center gap-2'>
                    <Typography className='text-[15px] font-medium leading-[22px]'>
                      {__n(detailItem.value, 'đ')}
                    </Typography>
                  </div>
                </div>

                {detailIndex !== servicesDetailItems.length - 1 && <Divider />}
              </div>
            ))}

          {index === 5 &&
            totalEwaDisbursementItems.map((detailItem, detailIndex) => (
              <div key={detailIndex}>
                <div className='flex flex-row gap-4 items-center py-1'>
                  <div className='flex flex-row items-center gap-2'>
                    <Typography className='text-[15px] font-normal leading-[22px]'>{__(detailItem.label)}</Typography>
                  </div>
                  <div className='flex items-center gap-2'>
                    <Typography className='text-[15px] font-medium leading-[22px]'>
                      {__n(detailItem.value, 'đ')}
                    </Typography>
                  </div>
                </div>

                {detailIndex !== totalEwaDisbursementItems.length - 1 && <Divider />}
              </div>
            ))}

          {index === 2 &&
            employeeFeeItems.map((detailItem, detailIndex) => (
              <div key={detailIndex}>
                <div className='flex flex-row gap-4 items-center py-1'>
                  <div className='flex flex-row items-center gap-2'>
                    <Typography className='text-[15px] font-normal leading-[22px]'>{__(detailItem.label)}</Typography>
                  </div>
                  <div className='flex items-center gap-2'>
                    <Typography className='text-[15px] font-medium leading-[22px]'>
                      {__n(detailItem.value, 'đ')}
                    </Typography>
                  </div>
                </div>

                <Divider />
              </div>
            ))}

          {index === 3 &&
            differentDetailItems.map((detailItem, detailIndex) => (
              <div key={detailIndex}>
                <div className='flex flex-row gap-4 items-center py-1'>
                  <div className='flex flex-row items-center gap-2'>
                    <Typography className='text-[15px] font-normal leading-[22px]'>{__(detailItem.label)}</Typography>
                  </div>
                  <div className='flex items-center gap-2'>
                    <Typography className='text-[15px] font-medium leading-[22px]'>
                      {__n(detailItem.value, 'đ')}
                    </Typography>
                  </div>
                </div>

                {detailIndex !== differentDetailItems.length - 1 && <Divider />}
              </div>
            ))}

          {index === 4 &&
            debtDetailItems.map((detailItem, detailIndex) => (
              <div key={detailIndex}>
                <div className='flex flex-row gap-4 items-center py-1'>
                  <div className='flex flex-row items-center gap-2'>
                    <Typography className='text-[15px] font-normal leading-[22px]'>{__(detailItem.label)}</Typography>
                  </div>
                  <div className='flex items-center gap-2'>
                    <Typography className='text-[15px] font-medium leading-[22px]'>
                      {__n(detailItem.value, 'đ')}
                    </Typography>
                  </div>
                </div>

                {detailIndex !== debtDetailItems.length - 1 && <Divider />}
              </div>
            ))}

          {index === 1 &&
            voucherDetailItems.map((detailItem, detailIndex) => (
              <div key={detailIndex}>
                <div className='flex flex-row gap-4 items-center py-1'>
                  <div className='flex flex-row items-center gap-2'>
                    <Typography className='text-[15px] font-normal leading-[22px]'>{__(detailItem.label)}</Typography>
                  </div>
                  <div className='flex items-center gap-2'>
                    <Typography className='text-[15px] font-medium leading-[22px]'>
                      {__n(detailItem.value, 'đ')}
                    </Typography>
                  </div>
                </div>

                {detailIndex !== voucherDetailItems.length - 1 && <Divider />}
              </div>
            ))}
        </div>
      )}
    </div>
  )

  return (
    <Card className='rounded-[16px]'>
      <CardContent className='p-6'>
        <div className='flex flex-col gap-6'>
          <div className='flex justify-between items-start'>
            {renderSummaryItem(summaryItems[0], 0)}
            <Divider orientation='vertical' flexItem className='mx-6' />
            {renderSummaryItem(summaryItems[1], 1)}
            <Divider orientation='vertical' flexItem className='mx-6' />
            {renderSummaryItem(summaryItems[2], 2)}
          </div>

          <Divider />

          <div className='flex justify-between items-start'>
            {renderSummaryItem(summaryItems[3], 3)}
            <Divider orientation='vertical' flexItem className='mx-6' />
            {renderSummaryItem(summaryItems[4], 4)}
            <Divider orientation='vertical' flexItem className='mx-6' />
            {renderSummaryItem(summaryItems[5], 5)}
          </div>

          {!showMore && (
            <div className='flex justify-end'>
              <div
                className='flex items-center gap-2 cursor-pointer text-gray-500 hover:text-gray-700'
                onClick={() => setShowMore(true)}
              >
                <Typography className='text-[14px]'>{__('View More')}</Typography>
                <i className='tabler-circle-arrow-down' />
              </div>
            </div>
          )}

          {showMore && (
            <div className='flex justify-end'>
              <div
                className='flex items-center gap-2 cursor-pointer text-gray-500 hover:text-gray-700'
                onClick={() => setShowMore(false)}
              >
                <Typography className='text-[15px] font-normal leading-[22px]'>{__('View Less')}</Typography>
                <i className='tabler-circle-arrow-up' />
              </div>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
